define('models/pages/organization/settings',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var OrganizationSettings = Model.extend({
        urlPath: '/page/organization/settings',
        defaults: {
            Name:'',
            Code: '',
            CountryName: '',
            TownName: '',
            _factAddress: '',
            _address: '',
            _phone: '',
            fax: '',
            skype: '',
            _email: '',
            _site: '',
            _ogrn: '',
            _inn: '',
            _kpp: '',
            _bank: '',
            _bik: '',
            _ks: '',
            _rs: '',
            currency: [],
            additionalInfo: ''
        },
        constructor: function() {
            Model.apply(this, arguments);
        },
        dispose: function() {
            if (this.disposed) { return; }
            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return OrganizationSettings;
});
